<template>
	<div >
 <div class="oh endetail_taglist" :key="ind" v-for="(list,ind) in tagtreelist" v-if="list.taglist.length>0 && list.name!='投资实力'">
 	<h5 class="title fl">{{list.name}}</h5>
 	<div class="fl"><span class="span-tag" :key="index" v-for="(item,index) in list.taglist" @click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name,'enterprisedetial')">{{item.name}}</span></div> 
 </div>  
 <div class="oh endetail_taglist"  v-if="tagtreelist1[0].taglist.length>0">
 	<h5 class="title fl">投资实力</h5>
 	<div class="fl">
 		<p :key="ind" v-for="(list,ind) in tagtreelist1" class="oh"><span class="span-tag" :key="index" v-for="(item,index) in list.taglist" @click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name,'enterprisedetial')">{{item.name}}</span></p>
 		</div> 
 </div>
	</div>
</template>

<script>
	export default {
		name:"enterpriseTaglist",
		props:{
			tagText:{type:String,request:true}, 
			tagCode:{type:String,request:true}, 
		},
		data(){
			return{
				echartWidth2:document.body.offsetWidth*0.8728*0.95*0.48, 
				tagarrylist:[
						{name:"综合实力",taglist:[],children:['2021全球独角兽','世界500强（内资）','世界500强（外资）','中国500强','央企','国有企业','中国民营企业500强','中国制造业民营企业500强',
						'中国服务业民营企业500强','重点企业','标杆企业','知名企业','猎豹企业','独角兽企业','瞪羚企业','雏鹰企业','隐形冠军企业','牛羚企业','上市公司','主板上市公司',
						'科创板上市公司','中小板上市公司','创业板上市公司','港股、美股上市公司','北交所上市公司','新上市','预备上市','新三板上市公司','战略性新兴产业领军企业100强',
						'专精特新中小企业','科技小巨人企业','专精特新小巨人企业','创新型企业','科技型中小企业', '民营科技企业','企业技术中心','科技企业孵化器','技术创新示范企业','技术先进型服务企业',
						'省级专精特新企业','省级专精特新小巨人企业','制造业单项冠军','高新技术企业','华为系','字节系','腾讯系','阿里系','百度系','京东系','美团系','小米系',]},
						{name:"技术实力",taglist:[],children:['国家科技支撑计划','国家科技重大专项','国家标准起草单位','国家薪火项目','国家级科学技术进步奖','国家地方联合工程研究中心','国家重大科学仪器设备开发专项','国家级工业设计中心','高新技术企业研发中心','企业国家重点实验室','认定企业技术中心','院士专家工作站','博士后工作站','博士后流动站','中国专利奖','研发人员多','研发投入多','研发能力强','专利多','有专利','证书多','有证书','专利质量高']},
						{name:"特色标签",taglist:[],children:['媒体热议','名校背景','名企背景','上市公司供应商','上市公司客户']},
						{name:"融资标签",taglist:[],children:['刚获投','连续获投','融资窗口期','刚上市','融资金额大','红杉资本中国','IDG资本','腾讯投资','知名投资机构','TOP10投资机构','TOP30投资机构','TOP50投资机构','尚未获投','种子轮','天使轮','Pre-A轮','A轮','A+轮','Pre-B轮','B轮','B+轮','C轮','C+轮','D轮','D+轮','E轮','E+轮','F轮','G轮','H轮','Pre-IPO','基石轮','已上市','新三板','已退市','战略投资','不明确','已被收购','已合并']},
						{name:"投资实力",taglist:[],children:['盈利能力强','偿债能力强','成长能力强','现金流稳健','近期有融资','连续融资','投资意愿强','项目投资数量多','近期有项目投资','有项目投资','连续项目投资','股权投资数量多','近期有股权投资','有股权投资','连续股权投资','拿地面积大','拿地数量多','有拿地','近期有拿地','连续拿地']},	
					],  
					tagarrlistSp:[
						{name:'a',children:['项目投资数量多','近期有项目投资','有项目投资','连续项目投资'],taglist:[]},
						{name:'b',children:['股权投资数量多','近期有股权投资','有股权投资','连续股权投资'],taglist:[]},
						{name:'c',children:['拿地面积大','拿地数量多','有拿地','近期有拿地','连续拿地'],taglist:[]},
						{name:'d',children:['盈利能力强','偿债能力强','成长能力强','现金流稳健','投资意愿强','近期有融资','连续融资'],taglist:[]}, 
				],
				tagtreelist:[],
				tagtreelist1:[{taglist:[],}],
			}
		},
		created() {
		 
		},
		mounted() {
			if(this.tagText && this.tagText!=""){
				this.gettagchainlist(this.tagText,this.tagCode); 
			} 
		},
		methods: {
			 gettagchainlist(tagname,tagcode){
			 	// console.log(tagname,tagcode);
			 	var localchain=this.tagarrylist;
			 	var localJstag=this.tagarrlistSp;
			 	var reschain=[],reschain1=[];
			 	var ddtaglist=this.taglistfun(tagname,tagcode); 
			 	for(var i=0; i<ddtaglist.length;i++){
			 		let arrts=ddtaglist[i],arrtsname=ddtaglist[i].name;
			 		for(var d=0;d<localJstag.length;d++){
			 			for(var s=0;s<localJstag[d].children.length;s++){
			 				if(localJstag[d].children[s] == arrtsname){
			 					localJstag[d].taglist.push(arrts);
			 				}
			 			}
			 		}  
			 	}
			 	for(var i=0; i<ddtaglist.length;i++){
			 		let arrts=ddtaglist[i],arrtsname=ddtaglist[i].name;
			 		for(var d=0;d<localchain.length;d++){
			 			for(var s=0;s<localchain[d].children.length;s++){
			 				if(localchain[d].children[s] == arrtsname){
			 					localchain[d].taglist.push(arrts);
			 				}
			 			}
			 		}  
			 	} 
			 	this.tagtreelist=localchain;
			 	this.tagtreelist1=localJstag;
			 },
			 
		 
		 
		}
	};
</script>

<style lang="scss">
 
</style>